import img1 from "../../../assets/img/city/1.jpg";
import img2 from "../../../assets/img/city/2.jpg";
import img3 from "../../../assets/img/city/3.jpg";
import img4 from "../../../assets/img/city/4.jpg";

import india_map from "../../../assets/img/india_map.jpg";

import { useTranslation } from "react-i18next";
const cityName = [
  {
    id: "1",
    title: "Mumbai",
    img_url: img1,
  },
  {
    id: "2",
    title: "Rajasthan",
    img_url: img2,
  },
  {
    id: "3",
    title: "Delhi",
    img_url: img3,
  },
  {
    id: "4",
    title: "Uttar Pradesh",
    img_url: img4,
  },
];
function Network() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <section className="sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="networkHeading">
                <div className="fisherman-content">
                  <h6>{t("Our Network")}</h6>
                  <h3>{t("Growing Greener Across India")} </h3>
                  <p>
                    With a strong presence across multiple cities and regions,
                    Vinca Horticulture & Landscape Pvt. Ltd. is committed to
                    transforming spaces into sustainable green environments. Our
                    expanding network ensures that quality landscaping and
                    horticultural excellence reach every corner of the country.
                  </p>
                </div>
                <p className="vinc">Vinca Horticulture & Landscape Pvt. Ltd.</p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="fisherman-content">
                <img src={india_map} alt="Branch Map" className="" />
              </div>
              <div className="row d-none">
                {cityName.map((item) => {
                  return (
                    <div className="col-lg-6 col-md-6" key={item.id}>
                      <div className="networkCity">
                        <img
                          src={item.img_url}
                          alt={item.title}
                          title={item.title}
                          className="imf-fluid"
                        />
                        <div className="text">
                          <p>{item.title}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="networkItem d-none">
            <ul className="namedd ">
              <li>
                <div className="networkNumber">
                  <h2>1 Million +</h2>
                  <p>{t("Customers")}</p>
                </div>
              </li>
              <li>
                <div className="networkNumber">
                  <h2>50 Thousands +</h2>
                  <p>{t("Products")}</p>
                </div>
              </li>
              <li>
                <div className="networkNumber">
                  <h2>1 Thousand +</h2>
                  <p>{t("Delivery Depot")}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Network;
